export const ValidationPatterns = {
  email: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/,
  otp: /^\d{6}$/,
  number: /^\d+$/,
  text: /[A-Za-z]+/,
  password: /^(?=.*\d)(?=.*[!@#$%^&*()-_=+{}])(?=.*[A-Z])(?=.*[a-z]).{6,}$/
}
